module.exports = __webpack_public_path__ + "static/media/picture-(235).b3b1aa70.JPG";